<template>
  <div class="ld-wrap">
    <div class="ld-toolbar">
      <span class="ld-title">
        <v-icon size="16" style="margin-right:6px;color:var(--ec-text-3)">mdi-cellphone-link</v-icon>
        Device List
      </span>
      <div class="u-search-bar ld-search">
        <v-icon size="16" color="grey">mdi-magnify</v-icon>
        <v-text-field
          v-model="searchUserLicence"
          placeholder="Search device…"
          dense flat solo hide-details clearable
          class="u-search-input"
        />
      </div>
    </div>

    <v-data-table :headers="headersFeature" :items="userDevices" :search="searchUserLicence" class="ec-table">
      <template v-slot:[`item.licence_key_id`]="{ item }">
        <span v-if="item.licence_key_id" class="u-status-pill u-pill--gray">Assigned</span>
        <span v-else class="u-status-pill u-pill--green">Assignable</span>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        <span class="u-date">{{ timeParserDate(item.created_at, 'detailTime') }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import converter from '@/mixins/converter'
export default {
  props: {
    userDevices: { type: Array, default: () => [] },
    licenceName: { type: String, default: '' }
  },
  data () {
    return {
      searchUserLicence: '',
      headersFeature: [
        { text: 'Assigned Licence ID', value: 'licence_key_id', align: 'center' },
        { text: 'Device Name', value: 'device_client_name', align: 'center' },
        { text: 'Device Label', value: 'device_label', align: 'center' },
        { text: 'Created At', value: 'created_at', align: 'center' }
      ]
    }
  },
  mixins: [converter],
  methods: {
    closeGeneratedLicenceKeysDialog () {
      this.$emit('closeGeneratedKeysDialog')
    }
  }
}
</script>

<style scoped>
.ld-wrap {
  background: var(--ec-surface);
  border-radius: var(--ec-radius);
  border: 1px solid var(--ec-border);
  overflow: hidden;
  box-shadow: var(--ec-shadow);
}

.ld-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ec-border);
  background: var(--ec-bg);
}
.ld-title {
  display: flex;
  align-items: center;
  font-size: .85rem;
  font-weight: 600;
  color: var(--ec-text-1);
  white-space: nowrap;
}
.ld-search {
  max-width: 240px;
  margin-bottom: 0 !important;
}

/* Table → global .ec-table in admin.css */
</style>
